module.exports = __webpack_public_path__ + "static/media/image_company.95d1d300.jpg";